import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex justify-start border-b-2 pt-5" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "px-2 inline-block align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListSortByAgreeCountPage = _resolveComponent("ListSortByAgreeCountPage")!
  const _component_ListSortByStartTimePage = _resolveComponent("ListSortByStartTimePage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["pb-2 px-2text-center cursor-pointer", 
          _ctx.selectedTab === tab.name
            ? 'text-warningColor border-b-2 border-warningColor'
            : 'text-gray-800 hover:text-warningColor '
        ]),
            key: tab.name,
            onClick: ($event: any) => (_ctx.selectedTab = tab.name)
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(tab.display), 1)
          ], 10, _hoisted_3))
        }), 128))
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.selectedTab === 'sortbyagree')
        ? (_openBlock(), _createBlock(_component_ListSortByAgreeCountPage, {
            key: 0,
            event: _ctx.event
          }, null, 8, ["event"]))
        : _createCommentVNode("", true),
      (_ctx.selectedTab === 'sortbytime')
        ? (_openBlock(), _createBlock(_component_ListSortByStartTimePage, {
            key: 1,
            event: _ctx.event
          }, null, 8, ["event"]))
        : _createCommentVNode("", true)
    ])
  ]))
}